"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseServerErrorResponse = exports.makePublicApiCall = exports.makePrivateApiCall = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _config = _interopRequireDefault(require("./config"));
var _helpers = require("./auth/helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const API_URL = _config.default.api_url;

/**
 *
 * @typedef ApiRequestConfig
 *
 * @property baseURL {string}
 * @property responseType {string}
 * @property method {string}
 * @property url {string}}}
 * @property headers {{Authorization: string}}
 */

/**
 *
 * @param {ApiRequestConfig} config
 * @return {ApiRequestConfig}
 */
const buildApiCallParams = config => {
  return {
    url: "/",
    method: "get",
    baseURL: API_URL + "/v1",
    responseType: "json",
    ...config
  };
};

/**
 * make private api call
 * @async
 * @function makePrivateApiCall
 *
 * @param {Object} config
 * @param {String} config.url	    Url to send the request
 * @param {String} config.method	    Method type eg: GET, POST
 * @param {String} config.responseType	    Data type of the response
 * @param {String} config.baseURL	    Base url to start the request with
 * @param {Object} config.headers     Add props to request headers
 *
 * @returns {Promise} Promise to return responded data
 */
const makePrivateApiCall = config => {
  const params = {
    headers: {
      Authorization: (0, _helpers.getAuthToken)()
    },
    ...buildApiCallParams(config)
  };
  return (0, _axios.default)(params);
};
exports.makePrivateApiCall = makePrivateApiCall;
const makePublicApiCall = config => {
  return (0, _axios.default)(buildApiCallParams(config));
};
exports.makePublicApiCall = makePublicApiCall;
const parseServerErrorResponse = err => {
  var _err$response;
  let messages = [];
  const data = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data) || null;
  if (!data) {
    messages.push(err.message);
  } else if (data.details) {
    data.details.forEach(({
      message
    }) => messages.push(message));
  } else if (data.message) {
    messages.push(data.message);
  }
  return messages;
};
exports.parseServerErrorResponse = parseServerErrorResponse;